var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paid-wrapper"},[_c('span',{staticClass:"paid-text"},[_vm._v(" Sua parcela foi paga com sucesso! ")])])
}]

export { render, staticRenderFns }